import React from 'react'
import { useSelector } from 'react-redux'
import ResponsiveTable from './ResponsiveTable';

function WishList() {
   const wishlist= useSelector(state=>state.wish);

  return (
    <div>
      
<ResponsiveTable cart={wishlist} status='wish'/>

    </div>
  )
}

export default WishList
